import React from "react"
import PropTypes from "prop-types"
import {Link} from "gatsby"
import {useDispatch, useSelector} from "react-redux"

import {recordUser} from "../../../redux/api/apiAction"
import BankTransferModal from "./bankTransferModal"
import CreditCardModal from "./creditCardModal"
import RefundModal from "./refundModal"
import {isDefined} from "../../../utils/data"
import TermsOfSales from "../../../components/termsOfSales/termsOfSales"

const Payment = ({total}) => {
    const dispatch  = useDispatch()
    const {user}    = useSelector(({apiReducer}) => apiReducer)
    const data      = useSelector(({registrationReducer}) => registrationReducer)
    const {stripe}  = useSelector(({registrationReducer}) => registrationReducer)

    const recordRegistration = (payment = false) => {
        dispatch(recordUser(user, data, payment === true ? 1 : 0))
        
    }

    return (
        <div className={"sr-card summary-block payment"}>
            <div className={"summary-header"}>
                Votre facture sera disponible après le congrès.
            </div>
        {isDefined(user) ? 
            <div className={"summary-header"}>
                <a className={"btn btn-sm btn-warning"} href={"https://demo.urevent.fr/documents/pro_forma/" + user.registered.idregistered} target="_blank">Téléchargez le Proforma</a>
            </div>
            :
            <div className={"summary-header"}>
                Votre facture pro forma sera disponible après l'enregistrement de votre inscription.
            </div>
        }
        <hr/>
            <div className={"summary-body"}>
                {isDefined(user) ? isDefined(user.registered.registered_payments) ?
                    parseFloat(user.registered.registered_payments) < parseFloat(total) ?
                        <>
                            <div className={"row title-payment"}>
                                Réglement
                            </div>
                            <div className={"row"}>
                                <button className={"btn btn-warning"}><CreditCardModal stripe={stripe} total={total - (parseFloat(user.registered.registered_payments) || 0)}/></button>
                            </div>
                            <div className={"row"}>
                                <button className={"btn btn-warning"}><BankTransferModal/></button>
                            </div>
                            <div className={"row"}>
                                Les virements sont possibles jusqu'à 10 jours avant le début du congrès.
                            </div>
                        </>
                        :
                        parseFloat(user.registered.registered_payments) > parseFloat(total) ?
                            <>
                                <div className={"row title-payment"}>
                                    Remboursement
                                </div>
                                <div className={"row"}>
                                    <button className={"btn btn-warning"}><RefundModal/></button>
                                </div>
                            </>
                            : "" : "" :
                    <>
                        <div className={"row title-payment"}>
                            Réglement
                        </div>
                        <div className={"row"}>
                            <button className={"btn btn-warning"}><CreditCardModal stripe={stripe} total={total}/></button>
                        </div>
                        <div className={"row"}>
                            <button className={"btn btn-warning"}><BankTransferModal/></button>
                        </div>
                        <div className={"row"}>
                            Les virements sont possibles jusqu'à 10 jours avant le début du congrès.
                        </div>
                    </>}
            </div>
            <hr/>
            <div className={"summary-footer"}>
                <div className={"row"}>
                    <Link to={"confirmation-record"}>
                        <button className={"btn btn-warning"} onClick={() => recordRegistration()}>Enregistrez votre inscription</button>
                    </Link>
                </div>
                <div className={"row"}>
                    <TermsOfSales />
                </div>
            </div>
        </div>
    )
}

Payment.propTypes = {
    total: PropTypes.string.isRequired,
}

export default Payment
